package com.patronat.top.features.usermanagement.presentation.create

import com.patronat.top.core.base.ViewEvent
import com.patronat.top.core.base.ViewSideEffect
import com.patronat.top.core.base.ViewState
import com.patronat.top.dto.UserRole
import com.patronat.top.dto.UserStatus
import com.patronat.top.library.media.data.FileSource

data class CreateOrUpdateUserState(
    val userId: String? = null,
    val avatarUrl: String? = null,
    val avatarMediaId: String? = null,
    val firstName: String = "",
    val lastName: String = "",
    val email: String = "",
    val phone: String = "",
    val role: UserRole = UserRole.MODERATOR,
    var status: UserStatus = UserStatus.ACTIVE,
    val isLoading: Boolean = false,
    val isAvatarUploading: Boolean = false
) : ViewState

sealed interface CreateOrUpdateUserEvent : ViewEvent {
    data class Initialize(val role: UserRole, val userId: String? = null) : CreateOrUpdateUserEvent

    data class OnDataChanged(
        val firstName: String,
        val lastName: String,
        val email: String,
        val phone: String
    ) : CreateOrUpdateUserEvent

    data class OnStatusChanged(val status: UserStatus) : CreateOrUpdateUserEvent
    data object OnAvatarClicked : CreateOrUpdateUserEvent
    data class OnAvatarSelected(val fileSource: FileSource) : CreateOrUpdateUserEvent
    data object OnSubmitClicked : CreateOrUpdateUserEvent
}

sealed interface CreateUpdateUserEffect : ViewSideEffect {
    data object OpenImagePicker : CreateUpdateUserEffect
    data object CloseScreen : CreateUpdateUserEffect
    data class ShowError(val message: String) : CreateUpdateUserEffect
}